// 引入预算期间数据请求模块
import dbc from '@/api/configCenter/dimension.period';

const module = {
  namespaced: true,
  state: {},
  actions: {
    /**
     * 获取 预算期间 数据列表
     * @param {*} store
     * @param {*} param
     */
    getPeriodList(context, param) {
      console.log('数据列表context', context);
      return dbc.getPeriodList(param).then((content) => content.list);
    },

    /**
     * 描述 新建和编辑 一条 预算期间 数据
     * @date 2021-08-11
     * @param {any} context
     * @param {any} param
     * @returns {any}
     */
    savePeriod(context, param) {
      return dbc.savePeriod(param).then((content) => content.data);
    },

    /**
     * 描述 通过id获取一条模板信息
     * @date 2021-08-11
     * @param {any} context
     * @param {any} param
     * @returns {any}
     */
    getPeriodById(context, param) {
      return dbc.getPeriodById(param).then((content) => content.data);
    },

    /**
     * 描述 使用id删除一条预算期间数据
     * @date 2021-08-11
     * @param {any} context
     * @param {any} param
     * @returns {any}
     */
    deletePeriodById(context, param) {
      return dbc.deletePeriodById(param).then((content) => content.data);
    },

    /**
     * 描述 检查期间名唯一性校验
     * @date 2021-08-11
     * @param {any} context
     * @param {any} param
     * @returns {any}
     */
    checkPeriodName(context, param) {
      return dbc.checkPeriodName(param).then((content) => content.data);
    },
  },
  mutations: {},
};

export default module;
